import BidAdjustmentOptView from './src/view/index';


export { BidAdjustmentOptView };
